import { createBrowserRouter } from 'react-router-dom'
import { External } from '../../layouts/External'
import RouterError from '../RouterError'
import { LegacyHcsProvider } from '../../components/legacy/LegacyHcsProvider'
import Requester from '../../components/Requester/Requester'
import { PatientCreation } from '../../components/Patient/Form/PatientCreation'
import { PatientEdition } from '../../components/Patient/Form/PatientEdition'

export default createBrowserRouter([
    {
        path: '/ext',
        errorElement: <RouterError />,

        children: [
            {
                path: '/ext/patient',
                element: (
                    <External>
                        <LegacyHcsProvider>
                            <PatientCreation isExternal />
                        </LegacyHcsProvider>
                    </External>
                ),
            },
            {
                path: '/ext/patient/:id',
                element: (
                    <External>
                        <LegacyHcsProvider>
                            <PatientEdition isExternal />
                        </LegacyHcsProvider>
                    </External>
                ),
            },
            {
                path: '/ext/requester',
                element: (
                    <External>
                        <LegacyHcsProvider>
                            <Requester isExternal mode="CREATION" />
                        </LegacyHcsProvider>
                    </External>
                ),
            },
            {
                path: '/ext/requester/:id',
                element: (
                    <External>
                        <LegacyHcsProvider>
                            <Requester isExternal mode="EDITION" />
                        </LegacyHcsProvider>
                    </External>
                ),
            },
        ],
    },
])
